import * as React from 'react';

import * as styles from './Week.css';

export const Week: React.FC<React.PropsWithChildren> = ({ children }) => {
  return <div className={styles['week']}>{children}</div>;
};
